module.exports = __webpack_public_path__ + "img/img-tennis-d.be2fa07a.png";